<app-auth-shell title="Nova senha" subtitle="Escolha uma senha segura">
  <form role="form" [formGroup]="formReset" (ngSubmit)="reset()">
    <div class="auth-field">
      <label class="auth-field__label" for="password">Senha</label>
      <div class="auth-field__control">
        <input
          id="password"
          type="password"
          formControlName="password"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Nova senha"
          autocomplete="new-password"
          maxlength="60"
          aria-describedby="password-rules"
          appFocus
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye"></i></span>
        </button>
      </div>
      <app-password-checklist [password]="formReset.get('password')?.value" />
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="confirmPassword">Confirmar senha</label>
      <div class="auth-field__control">
        <input
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Repita a senha"
          autocomplete="new-password"
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye"></i></span>
        </button>
      </div>
      @if (formReset.get('confirmPassword')?.dirty) { @if (formReset.get('confirmPassword')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formReset.get('confirmPassword')?.hasError('compare')) {
      <div class="auth-field__error">As senhas não conferem</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formReset.valid">Salvar senha</button>
  </form>
  <div class="auth-shell__links">
    <p class="auth-shell__links-text">
      Já tem uma conta?
      <a class="auth-link" [routerLink]="['/signin']">Entrar</a>
    </p>
    <p class="auth-shell__legal">
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">SOFTClass</a>
      ·
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">erpclass.com.br</a>
    </p>
  </div>
</app-auth-shell>
